import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular/main';
import { EQueryAdminSummary } from '../../admin/e-query/models/e-query-admin-summary';

@Component({
    selector: 'hidden-e-query-ag-renderer',
    template: require('./hidden-e-query-ag-renderer.component.html'),
    styles: [require('./hidden-e-query-ag-renderer.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HiddenEQUeryAgRendererComponent implements AgRendererComponent {
    public isHidden = false;

    constructor() {
    }

    public refresh(): boolean {
        return false;
    }

    public agInit({ data }: { data: EQueryAdminSummary }) {
        this.isHidden = data.isHidden;
    }
}
